module.exports = __webpack_public_path__ + "static/media/play.4969811a.svg";